import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

// お知らせの種類の表示名【2026-10-01】（以前は英語の種類名をそのまま出していた）
const TYPE_LABEL = {
  attendance_reminder: '授業のリマインダー', low_attendance_alert: '出席率', class_cancellation: '休講・代講',
  custom_message: '先生から', attendance_request_result: '出欠の申請', schedule_suggestion: '授業スケジュール',
  empty_session_suggestion: '出席0人の回', roster_suggestion: '履修者名簿',
};

export default function Notifications() {
  const [list, setList]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr]         = useState('');
  const [filter, setFilter]   = useState('all'); // all | unread

  const auth = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('token'),
    'Content-Type': 'application/json'
  });

  const load = async () => {
    setLoading(true); setErr('');
    try {
      const res  = await fetch('/api/notifications', { headers: auth() });
      const data = await res.json();
      setList(data.notifications || data.data || []);
    } catch (e) { setErr(e.message); }
    finally     { setLoading(false); }
  };

  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps -- 画面を開いたときに1回だけ

  const markRead = async (id) => {
    try {
      await fetch('/api/notifications/' + id + '/read', { method: 'PUT', headers: auth() });
      load();
    } catch (e) { setErr(e.message); }
  };

  const markAllRead = async () => {
    try {
      await fetch('/api/notifications/read-all', { method: 'PUT', headers: auth() });
      load();
    } catch (e) { setErr(e.message); }
  };

  const remove = async (id) => {
    if (!window.confirm('この通知を削除しますか？')) return;
    try {
      await fetch('/api/notifications/' + id, { method: 'DELETE', headers: auth() });
      load();
    } catch (e) { setErr(e.message); }
  };

  const visible = filter === 'unread' ? list.filter(n => !n.is_read) : list;
  const unread  = list.filter(n => !n.is_read).length;

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>通知センター</h1>
        <p>未読通知が <strong>{unread}</strong> 件あります。</p>
      </div>

      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.5rem' }}>
          <div className="tab-bar" style={{ marginBottom: 0 }}>
            <button className={'tab-btn' + (filter==='all'?' active':'')}    onClick={()=>setFilter('all')}>すべて</button>
            <button className={'tab-btn' + (filter==='unread'?' active':'')} onClick={()=>setFilter('unread')}>未読のみ</button>
          </div>
          <button className="btn-secondary" onClick={markAllRead} disabled={unread === 0}>
            すべて既読にする
          </button>
        </div>
      </div>

      {err && <div className="card" style={{borderLeft:'4px solid #ef4444'}}><p style={{color:'#c62828'}}>{err}</p></div>}
      {loading && <div className="card"><p>読み込み中...</p></div>}

      {!loading && visible.length === 0 && (
        <div className="card"><p style={{textAlign:'center',color:'#888',padding:'2rem'}}>通知はありません</p></div>
      )}

      {visible.map(n => (
        <div key={n.id} className="card" style={{
          borderLeft: '4px solid ' + (n.priority === 'high' ? '#ef4444' : n.priority === 'low' ? '#9ca3af' : '#3b82f6'),
          background: n.is_read ? '#fff' : '#eff6ff'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
            <div style={{ flex: 1 }}>
              <h3 style={{ fontSize: '1rem', fontWeight: 700, color: '#1e3a8a', marginBottom: '0.35rem' }}>
                {!n.is_read && <span style={{ color: '#2563eb' }}>● </span>}
                {n.title}
              </h3>
              <p style={{ color: '#444', marginBottom: '0.5rem', whiteSpace: 'pre-wrap' }}>{n.message}</p>
              {n.notification_type === 'roster_suggestion' && n.related_class_id && (
                <p style={{ margin: '0 0 0.5rem' }}>
                  <Link to={`/classes/${n.related_class_id}/roster`}>履修者名簿を取り込む →</Link>
                </p>
              )}
              {n.notification_type === 'schedule_suggestion' && n.related_class_id && (
                <p style={{ margin: '0 0 0.5rem' }}>
                  <Link to={`/classes/${n.related_class_id}/schedule`}>授業スケジュールを設定する →</Link>
                </p>
              )}
              {n.notification_type === 'empty_session_suggestion' && n.related_class_id && (
                <p style={{ margin: '0 0 0.5rem' }}>
                  <Link to={`/classes/${n.related_class_id}/summary`}>出席記録を開いて、回を確認・削除する →</Link>
                </p>
              )}
              <small style={{ color: '#888' }}>
                {n.notification_type ? '[' + (TYPE_LABEL[n.notification_type] || n.notification_type) + ']' : ''} {' '}
                {n.created_at ? new Date(n.created_at).toLocaleString('ja-JP') : ''}
              </small>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.35rem' }}>
              {!n.is_read && (
                <button className="btn-secondary" onClick={() => markRead(n.id)}>既読</button>
              )}
              <button className="btn-danger" onClick={() => remove(n.id)}>削除</button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
